"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8714],{

/***/ 42301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _prismicConfiguration = __webpack_require__(51427);
var _inspirationsLanding = _interopRequireDefault(__webpack_require__(8623));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedInspirationsLanding, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 2:
            _yield$getLanguage = _context2.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", cachedRequest);
          case 9:
            _context2.prev = 9;
            _context2.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: "inspirationslanding",
              uid: uid,
              lang: lang
            });
          case 12:
            response = _context2.sent;
            _context2.t0 = response === null || response === void 0 ? void 0 : response.data;
            if (!_context2.t0) {
              _context2.next = 17;
              break;
            }
            _context2.next = 17;
            return Promise.all(response.data.body.map(/*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(element) {
                var _element$primary$blog;
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        if (!(element.slice_type === "banner" && (_element$primary$blog = element.primary.blogger) !== null && _element$primary$blog !== void 0 && _element$primary$blog.id)) {
                          _context.next = 5;
                          break;
                        }
                        _context.next = 4;
                        return (0, _prismicConfiguration.Client)().getByID(element.primary.blogger.id);
                      case 4:
                        element.bloggerData = _context.sent;
                      case 5:
                        _context.next = 10;
                        break;
                      case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);
                        throw _context.t0;
                      case 10:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 7]]);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 17:
            mappedInspirationsLanding = (0, _inspirationsLanding["default"])(response.data);
            _context2.next = 20;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(uid, ".json"),
              result: mappedInspirationsLanding
            });
          case 20:
            return _context2.abrupt("return", mappedInspirationsLanding);
          case 23:
            _context2.prev = 23;
            _context2.t1 = _context2["catch"](9);
            _context2.next = 27;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 27:
            _yield$getLanguage2 = _context2.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context2.next = 32;
              break;
            }
            return _context2.abrupt("return", _cachedRequest);
          case 32:
            return _context2.abrupt("return", (0, _prismicErrorHandle["default"])(_context2.t1, "Prismic - inspirations landing"));
          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[9, 23]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 37976:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "GQ", ({
  enumerable: true,
  get: function get() {
    return _usePrismicInspirationsLanding["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicInspirationsLanding = _interopRequireDefault(__webpack_require__(54209));
var _fetcher = _interopRequireDefault(__webpack_require__(42301));

/***/ }),

/***/ 54209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(42301));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicInspirationsLanding = function usePrismicInspirationsLanding(uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, language, "usePrismicInspirationsLanding"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicInspirationsLanding;
exports["default"] = _default;

/***/ }),

/***/ 41012:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _Influencer = _interopRequireDefault(__webpack_require__(28901));
var _getRouteFromUrl = _interopRequireDefault(__webpack_require__(61328));
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  link: "/"
};
var InspirationsLandingBanner = function InspirationsLandingBanner(props) {
  var label = props.label,
    title = props.title,
    subtitle = props.subtitle,
    influencer = props.influencer,
    leftImage = props.leftImage,
    backgroundColor = props.backgroundColor,
    textColor = props.textColor,
    _props$link = props.link,
    link = _props$link === void 0 ? defaultProps.link : _props$link;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var route = link && (0, _getRouteFromUrl["default"])(link);
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      width: "100%",
      flexDirection: ["column", null, null, "row"]
    }
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 0.75,
      objectFit: "cover",
      flexBasis: "50%",
      maxHeight: "500px"
    },
    image: leftImage,
    mode: "cover",
    sizes: "(max-width: 960px) and (min-width: 10px) 100vw, 768px"
  }), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexBasis: "50%",
      flexDirection: "column",
      bg: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "white",
      color: textColor !== null && textColor !== void 0 ? textColor : "main",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      py: ["s10", null, null, 0]
    }
  }, influencer && __jsx(_Box["default"], {
    sx: {
      mb: "s10"
    }
  }, __jsx(_Image["default"], {
    image: influencer.image,
    sx: {
      display: "inline-block",
      width: "80px",
      height: "80px",
      borderRadius: "100px",
      border: "3px",
      borderStyle: "solid",
      borderColor: "white",
      overflow: "hidden"
    },
    sizes: "210px"
  })), __jsx(_Box["default"], {
    sx: {
      font: "xxl_sans",
      width: "75%",
      display: "inline-block",
      mb: "s10",
      mt: ["s9", null, null, 0]
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      font: "body",
      width: "50%",
      display: "inline-block"
    }
  }, subtitle, " ", __jsx(_Box["default"], {
    as: "span",
    sx: {
      position: "relative",
      top: "6px"
    }
  }, __jsx(ArrowRightIcon, null))))), __jsx(Link, {
    route: route,
    params: {
      url: link
    }
  }, __jsx(_LinkRaw["default"], {
    title: label,
    sx: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      textAlign: "center"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      py: "s4",
      px: "s6",
      font: "label2",
      bg: "white",
      border: "1px",
      borderColor: "main",
      borderStyle: "solid",
      color: "main",
      position: "relative",
      top: "-10px",
      display: label ? "static" : "none"
    }
  }, label))));
};
var _default = InspirationsLandingBanner;
exports.Z = _default;

/***/ }),

/***/ 60521:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _getRouteFromUrl = _interopRequireDefault(__webpack_require__(61328));
var __jsx = _react["default"].createElement;
var defaultProps = {
  link: "/"
};
var InspirationsLandingBox = function InspirationsLandingBox(props) {
  var label = props.label,
    description = props.description,
    image = props.image,
    _props$link = props.link,
    link = _props$link === void 0 ? defaultProps.link : _props$link;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    readMore: (0, _langLibrary["default"])("Read more")
  };
  var route = link && (0, _getRouteFromUrl["default"])(link);
  return __jsx(_Box["default"], {
    sx: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      pb: 100
    }
  }, __jsx(_Image["default"], {
    sx: {
      objectFit: "contain",
      aspectRatio: 1.333,
      width: "100%"
    },
    image: image,
    sizes: "(max-width: 1555px) and (min-width: 960px) 420px, (max-width: 960px) and (min-width: 10px) 100vw, 768px"
  }), __jsx(_Box["default"], {
    sx: {
      color: "main",
      bg: "beigeLight",
      p: "s8",
      textAlign: "center",
      width: "calc(100% - 90px)",
      position: "absolute",
      bottom: 0
    }
  }, __jsx(_Box["default"], {
    as: "h4",
    sx: {
      font: "heading3",
      mb: "s7"
    }
  }, label), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s",
      mb: "s7"
    }
  }, description), __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "label2"
    }
  }, translations.readMore)), __jsx(Link, {
    route: route,
    params: {
      url: link
    }
  }, __jsx(_LinkRaw["default"], {
    title: label,
    sx: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%"
    }
  })));
};
var _default = InspirationsLandingBox;
exports["default"] = _default;

/***/ }),

/***/ 8623:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var _blogger = _interopRequireDefault(__webpack_require__(38422));
var mapInspirationsLanding = function mapInspirationsLanding(response) {
  var _response$page_title$, _response$seodescript, _response$seotitle$;
  if (!response) return;
  var content = [];
  response.body.map(function (element) {
    if (element.slice_type === "banner") {
      var _element$primary$labe, _element$primary$url, _element$primary$url$, _element$primary$blur, _element$primary$titl, _element$primary$subt;
      content.push({
        type: "banner",
        label: element.primary.label ? (_element$primary$labe = element.primary.label[0]) === null || _element$primary$labe === void 0 ? void 0 : _element$primary$labe.text : false,
        link: (_element$primary$url = element.primary.url) === null || _element$primary$url === void 0 ? void 0 : (_element$primary$url$ = _element$primary$url.url) === null || _element$primary$url$ === void 0 ? void 0 : _element$primary$url$.replace("https://", ""),
        leftImage: (0, _image["default"])(element.primary.image, ((_element$primary$blur = element.primary.blurhash) === null || _element$primary$blur === void 0 ? void 0 : _element$primary$blur.length) > 0 && element.primary.blurhash[0].text),
        title: (_element$primary$titl = element.primary.title[0]) === null || _element$primary$titl === void 0 ? void 0 : _element$primary$titl.text,
        subtitle: (_element$primary$subt = element.primary.subtitle[0]) === null || _element$primary$subt === void 0 ? void 0 : _element$primary$subt.text,
        blogger: element.bloggerData ? (0, _blogger["default"])(element.bloggerData) : null,
        backgroundColor: element.primary.background_color,
        textColor: element.primary.text_color
      });
    }
    if (element.slice_type === "boxes") {
      var _element$primary$grou, _element$primary$grou2;
      var boxes = [];
      element.items.map(function (box) {
        var _box$title$, _box$blurhash, _box$url, _box$url$url, _box$subtitle$;
        boxes.push({
          label: (_box$title$ = box.title[0]) === null || _box$title$ === void 0 ? void 0 : _box$title$.text,
          image: (0, _image["default"])(box.image, ((_box$blurhash = box.blurhash) === null || _box$blurhash === void 0 ? void 0 : _box$blurhash.length) > 0 && box.blurhash[0].text),
          link: (_box$url = box.url) === null || _box$url === void 0 ? void 0 : (_box$url$url = _box$url.url) === null || _box$url$url === void 0 ? void 0 : _box$url$url.replace("https://", ""),
          description: (_box$subtitle$ = box.subtitle[0]) === null || _box$subtitle$ === void 0 ? void 0 : _box$subtitle$.text
        });
      });
      content.push({
        type: "boxes",
        label: element.primary.group_title[0].text,
        url: (_element$primary$grou = element.primary.group_url) === null || _element$primary$grou === void 0 ? void 0 : (_element$primary$grou2 = _element$primary$grou.url) === null || _element$primary$grou2 === void 0 ? void 0 : _element$primary$grou2.replace("https://", ""),
        boxes: boxes
      });
    }
  });
  return {
    title: response.page_title && ((_response$page_title$ = response.page_title[0]) === null || _response$page_title$ === void 0 ? void 0 : _response$page_title$.text),
    seoDescription: (_response$seodescript = response.seodescription[0]) === null || _response$seodescript === void 0 ? void 0 : _response$seodescript.text,
    seoTitle: (_response$seotitle$ = response.seotitle[0]) === null || _response$seotitle$ === void 0 ? void 0 : _response$seotitle$.text,
    content: content
  };
};
var _default = mapInspirationsLanding;
exports["default"] = _default;

/***/ }),

/***/ 69231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _InspirationsLandingBox = _interopRequireDefault(__webpack_require__(60521));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _getRouteFromUrl = _interopRequireDefault(__webpack_require__(61328));
var __jsx = _react["default"].createElement;
var defaultProps = {
  link: "/"
};
var ThreeInspirationBoxes = function ThreeInspirationBoxes(props) {
  var label = props.label,
    boxes = props.boxes,
    _props$link = props.link,
    link = _props$link === void 0 ? defaultProps.link : _props$link;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    showAll: (0, _langLibrary["default"])("show all")
  };
  var route = (0, _getRouteFromUrl["default"])(link);
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      position: "relative",
      pt: ["s9", null, null, 0]
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row"],
      flexWrap: "no-wrap",
      width: "100%",
      justifyContent: "space-between"
    }
  }, boxes.slice(0, 3).map(function (box, index) {
    return __jsx(_Box["default"], {
      sx: {
        flex: ["100%", null, null, "32%"],
        maxWidth: ["100%", null, null, "32%"],
        mt: index == 1 ? [0, null, null, "75px"] : 0,
        position: "relative",
        zIndex: 1,
        mb: ["s11", null, null, 0]
      },
      key: index + box.label
    }, __jsx(_InspirationsLandingBox["default"], {
      label: box.label,
      link: box.link,
      description: box.description,
      image: box.image
    }));
  })), __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: ["22px", null, null, 0],
      width: "100%",
      textAlign: "center",
      zIndex: [2, null, null, "unset"]
    }
  }, __jsx(Link, {
    route: route,
    params: {
      url: link
    }
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      py: "s4",
      px: "s6",
      font: "label2",
      bg: "white",
      border: "1px",
      borderColor: "main",
      borderStyle: "solid",
      color: "main"
    }
  }, label), __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "s_italic",
      mt: "s7",
      display: ["none", null, null, "block"]
    }
  }, translations.showAll)))));
};
var _default = ThreeInspirationBoxes;
exports.Z = _default;

/***/ })

}]);